<template>
  <div class="chat-file-uploader">
    <div class="m-3" id="drag-drop"></div>
  </div>
</template>

<script>
import Uppy from '@uppy/core'
import XHRUpload from '@uppy/xhr-upload'
import Dashboard from '@uppy/dashboard'
import { mapActions } from 'vuex'

export default {
  props: ['orderId'],
  data() {
    return {}
  },

  computed: {},

  mounted() {
    new Uppy({
      autoProceed: true,
      restrictions: {
        maxNumberOfFiles: 1,
      }
    })
        .use(Dashboard, {
          inline: true,
          target: '#drag-drop',
          hideUploadButton: false,
          browserBackButtonClose: false
        })
        .use(XHRUpload, {
          endpoint: process.env.VUE_APP_API_URL + '/orders/' + this.orderId + '/messages/attachment',
          formData: true,
          fieldName: 'attachment',
          headers: {
            'Authorization': this.$store.state.upload.options.headers.Authorization
          }
        })
        .on('file-added', function () {

          //  document.querySelector("#order-message-reply-btn").setAttribute("disabled","disabled");
        })
        .on('upload-success', (data, response) => {

          //change message object property name for adjusting with message item
          response.body['owner'] = response.body['user'];
          response.body['created_at'] = 'just now';
          delete response.body['user'];

          this.addMessage(response.body);
          setTimeout(function () {
            window.$("#drag-drop").find('.uppy-u-reset.uppy-StatusBar-actionBtn--done').trigger("click");
          }, 300)

          setTimeout(() => {
            document.querySelector("#orderMessageModalBody").scrollIntoView({behavior: 'smooth', block: 'end'});
          }, 500);

        });
  },

  methods: {
    ...mapActions({
      addMessage: "message/addMessage",
    }),
  }
}
</script>

<style lang="css">
/* @import 'https://releases.transloadit.com/uppy/v2.10.0/uppy.min.css'; */

.chat-file-uploader .uppy-Dashboard-inner {
  width: 100% !important;
  height: auto !important;
}

.chat-file-uploader .uppy-DashboardContent-bar {
  display: none;
}

.chat-file-uploader .uploader-container {
  max-width: 280px !important;
}

.chat-file-uploader .uppy-Dashboard-AddFiles-title {
  font-size: 13px;
  margin-top: 5px;
}

.chat-file-uploader .kt-chat .kt-chat__input .kt-chat__toolbar {
  margin-top: -22px;
}
</style>

